import _PaperBasedHomeworkResult from './model';
import create from './create';

const PaperBasedHomeworkResult = _PaperBasedHomeworkResult;

PaperBasedHomeworkResult.create = create;
export default PaperBasedHomeworkResult;



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/PaperBasedHomeworkResult/index.js